import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CrowdstrikeService } from '../../service';

export type MissingAgentsConfig = typeof MissingAgentsConfig._.Config;

export const MissingAgentsConfig = IntegrationConfig.make({
  service: CrowdstrikeService,
  name: Integration_Handler_Names_Enum.MissingAgents,
  configSchema: z.object({
    maxMissingDays: z.number().min(1),
    hostPatternFilter: patternFilterSchema.optional(),
  }),
});
